import type {ApiWorkforceProfileRecord} from '../WorkforceProfiles/workforceProfileApiTypes';

import type {TargetProfileAlignmentAssessmentScope} from '../../types/WorkforceProfileTypes';

const toNumber = (value: unknown): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const mapTargetProfileAlignmentAssessmentScope = (
  raw: ApiWorkforceProfileRecord | undefined
): TargetProfileAlignmentAssessmentScope | null => {
  const scope =
    (raw?.targetProfileAlignmentAssessmentScope as ApiWorkforceProfileRecord | undefined) ??
    (raw?.target_profile_alignment_assessment_scope as ApiWorkforceProfileRecord | undefined);

  if (!scope || typeof scope !== 'object') {
    return null;
  }

  const representative = Boolean(scope.representative);
  const skillsTotal = toNumber(scope.skillsTotal ?? scope.skills_total);
  const skillsInScope = toNumber(scope.skillsInScope ?? scope.skills_in_scope);

  if (!representative && skillsTotal === 0 && skillsInScope === 0) {
    return null;
  }

  return {
    representative,
    skillsTotal,
    skillsInScope,
    coreTotal: toNumber(scope.coreTotal ?? scope.core_total ?? scope.competenceTotal ?? scope.competence_total),
    coreInScope: toNumber(
      scope.coreInScope ?? scope.core_in_scope ?? scope.competenceInScope ?? scope.competence_in_scope
    ),
    hardTotal: toNumber(scope.hardTotal ?? scope.hard_total ?? scope.knowledgeTotal ?? scope.knowledge_total),
    hardInScope: toNumber(
      scope.hardInScope ?? scope.hard_in_scope ?? scope.knowledgeInScope ?? scope.knowledge_in_scope
    ),
    softTotal: toNumber(scope.softTotal ?? scope.soft_total),
    softInScope: toNumber(scope.softInScope ?? scope.soft_in_scope),
    responsibilityTotal: toNumber(scope.responsibilityTotal ?? scope.responsibility_total),
    responsibilityInScope: toNumber(scope.responsibilityInScope ?? scope.responsibility_in_scope),
  };
};
